export default __webpack_public_path__ + "static/media/unacceptable-photo-wrong-background.7cc55a6a.png";